import { useEffect } from 'react';

export const useSetRestricted = (callback: (isEnabled: boolean) => void, dependency: Array<any>) => {
  useEffect(() => {
    if (!dependency) {
      callback(false);
    }
  }, dependency);
};
